import { call, put, select, takeLatest } from 'redux-saga/effects';

import { createStandaloneToast, theme } from '@frontend/components';

import { invalidateAllAssemblyTreeQueries } from 'modules/quotes/quoteItemComponents/assemblyTree/data/utils';
import { selectComponent } from 'modules/quotes/quoteItemComponents/data/actions';
import {
  collapseQuoteItem,
  refreshQuoteItem,
  removeQuoteItems,
} from 'modules/quotes/quoteItems/data/actions';
import { getQuoteItemId } from 'modules/quotes/quoteItems/modals/ReplaceParentDrawer/data/reducer';

import quoteService from 'services/quoteService';

import { refreshQuote } from 'store/quotes/actions';
import { getQuoteItemById } from 'store/quotes/selectors';

import { types, replaceParentDrawer } from './actions';

const { toast } = createStandaloneToast({ theme });

export default function* root() {
  yield takeLatest(types.SUBMIT, watchSubmit);
}

function* watchSubmit(action) {
  try {
    const { payload } = action;
    const { isReplacingRootComponent, partUuid } = payload;

    if (isReplacingRootComponent) {
      yield put(collapseQuoteItem.request());
    }

    yield call(quoteService.components.replaceParent, partUuid);

    const quoteItemId = yield select(getQuoteItemId);
    if (isReplacingRootComponent) {
      const quoteItem = yield select(getQuoteItemById, quoteItemId);
      yield put(removeQuoteItems([quoteItem]));
      yield put(refreshQuote.request());
    } else {
      invalidateAllAssemblyTreeQueries();
      yield put(
        refreshQuoteItem({
          quoteItemId,
          shouldRecalculate: false,
        }),
      );
    }

    yield put(selectComponent.deselectAll());
    yield put(replaceParentDrawer.success());

    toast({
      title: `Success`,
      description: 'Replaced assembly with child component.',
      status: 'success',
    });
  } catch (e) {
    yield put(replaceParentDrawer.failure());
    console.error(e);

    toast({
      title: `Failed to replace assembly with child component`,
      description: e.message,
      status: 'error',
    });
  }
}
